export function isMobileBrowser() {
  const { navigator } = window;
  if (/Android|iPhone|iPad|Mobile|iOS/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

export function mobileBrowserRedirectionUrl(location) {
  return `https://${location.host}/w/mobilebrowserredirect/`;
}

export default { isMobileBrowser, mobileBrowserRedirectionUrl };
